<template>
  <form
    id="main-search-input-container"
    @submit.prevent="handleQuerySubmission"
    class="flex flex-col justify-center gap-4 py-4 px-2 md:flex-row md:gap-2"
  >
    <FormInputText
      v-model="query"
      name="query"
      type="text"
      placeholder="Busca plazas"
      icon="search-outline"
      size="large"
      class="!py-0 flex justify-center"
      rounded
      elevated
    />
    <div>
    </div>
    <Button
      type="submit"
      class="btn-elevated max-w-fit mx-auto md:mx-0 h-14"
      size="large"
      :isLoading="isSearching"
    >
      {{ isSearching ? 'Buscando...' : 'Buscar' }}
    </Button>
  </form>
</template>

<script>
import Button from '@/Components/Button'
import FormInputText from '@/Components/FormInputText'
import FormSelect from '@/Components/FormSelect'

export default {
  name: 'SearchBar',
  props: {
    locations: { type: Array, required: false },
    queryParams: {
      type: Object,
      required: false,
      default: () => {
        return { query: '', location: '' }
      },
    },
  },
  components: { Button, FormInputText, FormSelect },
  data() {
    return {
      query: this.queryParams.query,
      location_query: this.queryParams.location,
      isSearching: false,
    }
  },
  methods: {
    handleQuerySubmission() {
      const queryParams = {
        query: this.query,
      }
      if (this.location_query) queryParams.location = this.location_query

      this.$inertia.get(this.$route('search'), queryParams, {
        onBefore: () => (this.isSearching = true),
        onFinish: () => (this.isSearching = false),
      })
    },
  },
}
</script>
